define( [
	"../Data"
], function( Data ) {
	return new Data();
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/data/var/dataUser.js
 ** module id = 856
 ** module chunks = 2
 **/